<template>
    <div>
        <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert>
        
        <b-card title="RFx Response" no-body class="shadow-sm spl-card-nav spl-nav-primary">
            
            <b-tabs 
                ref="combinedTabs"
                v-model="activeTabIndex"
                @activate-tab="onActivateTab"
                lazy 
                fill 
                no-nav-style
            >
                
                <b-tab>
                    <template #title>
                        <span class="h4 mr-2">1</span>
                        Contact Information
                    </template>
                    
                    <div class="w-100 h-100">
                        <div class="py-5 d-flex justify-content-center align-items-center">
                            <div class="max-width-700">
                                <div class="mb-4">
                                    <h4>Contact Information</h4>
                                    <p class="text-muted">Please confirm this information is correct.</p>
                                    <p class="text-muted">If you need to delegate your response to a colleague, you may add them as a Team Member by clicking the button at the bottom.</p>
                                </div>
                                <div class="d-flex">
                                    <div class="w-35 text-muted">
                                        Your Name
                                    </div>
                                    <div class="font-weight-bold">
                                        {{ $currentUserInfo.full_name }}
                                    </div>
                                </div>
                                <hr>
                                <div class="d-flex">
                                    <div class="w-35 text-muted">
                                        Your Company
                                    </div>
                                    <div class="font-weight-bold">
                                        {{ $currentUserInfo.company_name }}
                                    </div>
                                </div>
                                <hr>
                                <div class="d-flex">
                                    <div class="w-35 text-muted pr-2">
                                        Team Members
                                    </div>
                                    <div class="w-65">
                                        <p class="">
                                            All people at your company with access to this Sourcing Event:
                                        </p>
                                        <vendor-rfx-response-invited-tus
                                            class="w-100"
                                            :response-id="responseId"
                                        ></vendor-rfx-response-invited-tus>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </b-tab>

                <b-tab>
                    <template #title>
                        <span class="h4 mr-2">2</span>
                        Response Forms
                    </template>
                    
                    <div class="row">
                        <div class="col-12 mt-3">
                            <div class="px-4 py-3">
                                <h4>Response Forms</h4>
                                <p class="text-muted lead">Please complete all of the items below before proceeding to the next step.</p>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="px-4 py-2">

                                <portal-rfx-todo-list
                                    :response-id="responseId"
                                ></portal-rfx-todo-list>

                            </div>
                        </div>
                    </div>

                </b-tab>

                <b-tab>
                    <template #title>
                        <span class="h4 mr-2">3</span>
                        Review &amp; Submit
                    </template>
                    
                    <portal-rfx-response-submit
                        :response-id="responseId"
                        @submitted="handleResponseSubmitted"
                    ></portal-rfx-response-submit>

                </b-tab>

                <b-tab
                    v-if="externalMessageThreadId"
                >
                    <template #title>
                        <b-icon icon="envelope" font-scale="1.5" class="mr-2"></b-icon>
                        Messages
                    </template>
                    <div class="row">
                        <div class="col-12">
                            <div class="px-4 py-3">
                                <base-message-thread
                                    :thread-id="externalMessageThreadId"
                                    title="Messages with Buyer"
                                    subtitle="Ask questions, or respond to buyer feedback.  You will receive any replies by email, and here in the app."
                                    message-name="message"
                                    create-verb="New"
                                    editor-style="rich"
                                    thread-type="email"
                                    hide-internal-members
                                ></base-message-thread>
                            </div>
                        </div>
                    </div>

                </b-tab>

            </b-tabs>
        </b-card>
        <!-- Next / Previous buttons -->
        <div class="w-100 d-flex justify-content-between align-items-center my-3">
            <div class="minw-40">
                <b-button 
                    v-if="activeTabIndex > 0"
                    key="previousButton"
                    variant="sharp-secondary" 
                    block 
                    size="lg" 
                    @click="activeTabIndex--"
                >&larr; Previous Step</b-button>
                <div v-else key="noPreviousButton"></div>
            </div>

            <div class="minw-40">
                <b-button 
                    v-if="!tabCount || (tabCount && activeTabIndex < (tabCount - 1))"
                    key="nextButton"
                    variant="sharp-success" 
                    block 
                    size="lg" 
                    @click="activeTabIndex++"
                >Next Step &rarr;</b-button>
                <div v-else key="noNextButton"></div>
            </div>
            
        </div>


    </div>
</template>

<script>
import { errorHandling, currentUserInfoMixin } from '../../js/custom-vue-mixins';

export default {
    name: 'PortalRfxResponseCombined',
    components: {},
    mixins: [
        errorHandling,
        currentUserInfoMixin,
    ],
    props: {
        responseId: {
            type: String,
            required: true,
        },
        externalMessageThreadId: {
            // later, fetch the RfxResponse and related things in this component, then you don't need this prop
            type: String,
            required: false,
        },
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            activeTabIndex: 0,  // v-model with tabs 
            tabCount: 3,  // set on mounted, or whenever you know you have the b-tabs component in DOM
        }
    },
    computed: {
        
    },
    mounted() {
        //this.setTabCount();
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        setTabCount() {  // NOT WORKING
            const tabComp = this.$refs['combinedTabs'];
            this.tabCount = tabComp ? tabComp.$data.tabs.length : null;
        },
        handleResponseSubmitted() {
            // called from @submitted event on submission form -- when it was a successful submit
            // could be a new submit, or revised submit
            // we'll tell parent, so parent can reload things and refresh state machine stuff
            this.$emit('submitted');  // just tell parent we had a submit -- new vs. modified?  
        },
        onActivateTab: function (activeTabIndex) {
            this.activeTabIndex = activeTabIndex;
            location.hash = activeTabIndex;
        },
    },
    created: function () {
        this.activeTabIndex = parseInt(location.hash.replace("#", "") || 0);
    },
}
</script>

<style>

</style>